import {
    ChangeDetectionStrategy,
    Component,
    input,
    output,
    viewChildren,
} from '@angular/core';
import { MatMenuItem, MatMenuModule } from '@angular/material/menu';
import {
    type DataStateImage,
    EmptyState,
    HERO_ICONS,
    QpxMetadata,
    QpxTypography,
    RelativeDatePipe,
} from '@quipex/shared/ui';
import type { QuippyChatRef, QuippyHistoryItem } from '../../../runtime';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'div[qpx-quippy-chat-history]',
    imports: [
        EmptyState,
        MatMenuModule,
        QpxMetadata,
        QpxTypography,
        RelativeDatePipe,
    ],
    templateUrl: './chat-history.html',
    styleUrls: ['./chat-history.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'thread-list',
    },
})
export class QuippyChatHistory {
    private readonly items = viewChildren(MatMenuItem);

    protected readonly emptyStateImage: DataStateImage =
        HERO_ICONS.cabinetClock.sm;

    public readonly currentChatRef = input.required<QuippyChatRef>();
    public readonly chats = input.required<readonly QuippyHistoryItem[]>();
    public readonly selectChat = output<QuippyChatRef>();

    public focusFirstItem(): void {
        this.items()[0]?.focus('keyboard');
    }

    protected scopeBuildingName(chat: QuippyHistoryItem): string {
        return chat.scope.kind === 'building'
            ? (chat.buildingName ?? chat.scope.buildingId)
            : '';
    }

    protected onSelect(ref: QuippyChatRef): void {
        this.selectChat.emit(ref);
    }
}
